import VerificationSuccess from "./VerificationSuccess";

export default VerificationSuccess;
